import axios from 'axios';
import Radio from 'components/CustomRadio/CustomRadio.jsx';
import immutable from 'object-path-immutable';
import React, { Component } from 'react';
import { Col, Grid, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';
import Select from 'react-select';
import swal from 'sweetalert';
import undefsafe from 'undefsafe';
import CommissionLabel from '../../../components/CommissionLabel';
import SalePackageLabel from '../../../components/SalePackageLabel';
import Button from '../../../components/CustomButton/CustomButton';
import * as K from '../redux/QuotationsConstants';

class flightQuotationAdd extends Component {
  constructor(props) {
    super(props);
    this.FlightDefault = {
      type: '',
      airline: '',
      flightNumber: '',
      originatingCity: '',
      destinationCity: '',
      datetimeDeparture: '',
      datetimeReturn: '',
    };

    this.state = {
      formData: {
        airline: '',
        flightNumber: '',
        originatingCity: '',
        destinationCity: '',
        datetimeDeparture: '',
        datetimeReturn: '',
        buyprice: 0,
        price: 0,
        operator: '',
        comments: '',
        flights: [this.FlightDefault],
      },
      optionsSelect: {
        operators: [],
      },
      edit: '',
    };
  }

  componentWillMount() {
    this.getOptionsSelect(
      'operators',
      process.env.REACT_APP_URL_API + '/api/operators',
      (option) => {
        return {
          label: option.name,
          value: option.id,
        };
      },
    );
  }

  componentWillReceiveProps(nextProps) {
    var newForm = nextProps.Quotations.dataToEdit.flight;
    this.state.edit = newForm;
    if (newForm.operator !== undefined) {
      this.setState({
        formData: newForm,
      });
    }
  }

  getOptionsSelect = async (name, url, optionCreateFunction) => {
    const response = await axios.get(url);

    const options = response.data
      .filter((option) => option.isDeleted !== true)
      .map(optionCreateFunction)
      .sort((a, b) => {
        return a.label.toLowerCase().localeCompare(b.label.toLowerCase());
      });

    this.setState({
      optionsSelect: {
        ...this.state.optionsSelect,
        [name]: options,
      },
    });
  };

  onCloseModal = () => {
    this.setState({
      formData: {
        buyprice: 0,
        price: 0,
        operator: '',
        comments: '',
        flights: [this.FlightDefault],
      },
    });
    this.props.dispatch({
      type: K.CLOSE_MODAL_ADD,
      payload: 'flight',
    });
  };

  onAdd = () => {
    if (this.state.edit.flights !== undefined) {
      this.props.dispatch({
        type: K.UPDATE_FLIGHT,
        payload: {
          data: {
            value: this.state.formData,
            index: this.props.Quotations.indexToEdit,
          },
        },
      });
      this.props.dispatch({
        type: K.CLOSE_MODAL_ADD,
        payload: 'flight',
      });
    } else {
      this.props.dispatch({
        type: K.ADD_FLIGHT,
        payload: this.state.formData,
      });
      this.props.dispatch({
        type: K.CLOSE_MODAL_ADD,
        payload: 'flight',
      });
    }
    this.setState({
      formData: {
        buyprice: '',
        price: '',
        operator: '',
        comments: '',
        flights: [this.FlightDefault],
      },
    });
  };

  onChange = (path, value) => {
    var newFormData = immutable.set(this.state.formData, path, value);
    this.setState({
      formData: newFormData,
    });
  };

  alertInfo = async (msg) => {
    await swal('Atención!!', msg, {
      icon: 'warning',
      timer: 2000,
      buttons: false,
    });
  };

  handledPrices = () => {
    const {
      formData: { price, buyprice, operator },
    } = this.state;
    const isPackage = this.props.Quotations.generalQuotation.isPackage || false;

    if (this.formAdd.reportValidity()) {
      if (isPackage) {
        if (operator === '') {
          this.alertInfo('Selecciona un operador');
        } else {
          this.onAdd();
        }
      }

      const result = price - buyprice;

      if (result > 0) {
        this.onAdd();
      } else {
        this.alertInfo('La ganancia debe ser mayor a 0');
        return;
      }
    }
  };

  addFlight = () => {
    var newFormData = immutable.push(
      this.state.formData,
      'flights',
      this.FlightDefault,
    );
    this.setState({
      formData: newFormData,
    });
  };

  removeFlight = (indexFlight) => {
    var newFormData = immutable.del(this.state.formData, [
      'flights',
      indexFlight,
    ]);
    this.setState({
      formData: newFormData,
    });
  };

  render() {
    const {
      Quotations: {
        modalAddStatus,
        generalQuotation: { isPackage = false },
      },
    } = this.props;
    const { formData, optionsSelect } = this.state;

    return (
      <div>
        <Modal
          open={undefsafe(modalAddStatus, 'flight') || false}
          onClose={this.onCloseModal}
          styles={{
            modal: { width: '100%' },
            overlay: { alignItems: 'flex-start' },
          }}
          closeOnOverlayClick={false}
        >
          <form
            ref={(ref) => {
              this.formAdd = ref;
            }}
          >
            <Grid fluid>
              <Row>
                <Col md={12}>
                  <h5>Agregar vuelo</h5>
                  <SalePackageLabel isPackage={isPackage} />
                </Col>
              </Row>
              {this.state.formData.flights !== undefined
                ? this.state.formData.flights.map((flight, indexFlight) => (
                    <div key={indexFlight}>
                      <Row>
                        <Col md={10}>
                          <div className="form-group">
                            <label
                              htmlFor="buyprice"
                              style={{ fontWeight: '400' }}
                            >
                              <strong>VUELO {indexFlight + 1}</strong>
                            </label>
                            <Row>
                              <Col md={12}>
                                <div className="form-group ">
                                  <Radio
                                    number={indexFlight + 'a'}
                                    option="ida"
                                    name={indexFlight + 1}
                                    onChange={(event) =>
                                      this.onChange(
                                        ['flights', indexFlight, 'type'],
                                        'ida',
                                      )
                                    }
                                    checked={
                                      formData.flights[indexFlight].type ===
                                      'ida'
                                    }
                                    label="Ida"
                                    required
                                  />
                                  <Radio
                                    number={indexFlight + 'b'}
                                    option="regreso"
                                    name={indexFlight + 1}
                                    onChange={(event) =>
                                      this.onChange(
                                        ['flights', indexFlight, 'type'],
                                        'regreso',
                                      )
                                    }
                                    checked={
                                      formData.flights[indexFlight].type ===
                                      'regreso'
                                    }
                                    label="Regreso"
                                    required
                                  />
                                </div>
                              </Col>
                            </Row>

                            <Row>
                              <Col md={6}>
                                <div className="form-group">
                                  <label
                                    htmlFor="airline"
                                    style={{ fontWeight: '400' }}
                                  >
                                    AEROLINEA
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="airline"
                                    required
                                    value={
                                      formData.flights[indexFlight].airline
                                    }
                                    onChange={(event) =>
                                      this.onChange(
                                        ['flights', indexFlight, 'airline'],
                                        event.target.value,
                                      )
                                    }
                                  />
                                </div>
                              </Col>

                              <Col md={6}>
                                <div className="form-group">
                                  <label
                                    htmlFor="flightNumber"
                                    style={{ fontWeight: '400' }}
                                  >
                                    NÚMERO DE VUELO
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="flightNumber"
                                    value={
                                      formData.flights[indexFlight].flightNumber
                                    }
                                    onChange={(event) =>
                                      this.onChange(
                                        [
                                          'flights',
                                          indexFlight,
                                          'flightNumber',
                                        ],
                                        event.target.value,
                                      )
                                    }
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col md={6}>
                                <div className="form-group">
                                  <label
                                    htmlFor="originatingCity"
                                    style={{ fontWeight: '400' }}
                                  >
                                    ORIGEN
                                  </label>
                                  <input
                                    required
                                    type="text"
                                    className="form-control"
                                    id="originatingCity"
                                    value={
                                      formData.flights[indexFlight]
                                        .originatingCity
                                    }
                                    onChange={(event) =>
                                      this.onChange(
                                        [
                                          'flights',
                                          indexFlight,
                                          'originatingCity',
                                        ],
                                        event.target.value,
                                      )
                                    }
                                  />
                                </div>
                              </Col>
                              <Col md={6}>
                                <div className="form-group">
                                  <label
                                    htmlFor="destinationCity"
                                    style={{ fontWeight: '400' }}
                                  >
                                    DESTINO
                                  </label>
                                  <input
                                    required
                                    type="text"
                                    className="form-control"
                                    id="destinationCity"
                                    value={
                                      formData.flights[indexFlight]
                                        .destinationCity
                                    }
                                    onChange={(event) =>
                                      this.onChange(
                                        [
                                          'flights',
                                          indexFlight,
                                          'destinationCity',
                                        ],
                                        event.target.value,
                                      )
                                    }
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col md={6}>
                                <div className="form-group">
                                  <label
                                    htmlFor="datetimeDeparture"
                                    style={{ fontWeight: '400' }}
                                  >
                                    FECHA Y HORA DE PARTIDA
                                  </label>
                                  <input
                                    required
                                    className="form-control"
                                    id="datetimeDeparture"
                                    value={
                                      formData.flights[indexFlight]
                                        .datetimeDeparture
                                    }
                                    onChange={(event) =>
                                      this.onChange(
                                        [
                                          'flights',
                                          indexFlight,
                                          'datetimeDeparture',
                                        ],
                                        event.target.value,
                                      )
                                    }
                                    type="datetime-local"
                                  />
                                </div>
                              </Col>
                              <Col md={6}>
                                <div className="form-group">
                                  <label
                                    htmlFor="datetimeReturn"
                                    style={{ fontWeight: '400' }}
                                  >
                                    FECHA Y HORA DE LLEGADA
                                  </label>
                                  <input
                                    required
                                    className="form-control"
                                    id="datetimeReturn"
                                    value={
                                      formData.flights[indexFlight]
                                        .datetimeReturn
                                    }
                                    onChange={(event) =>
                                      this.onChange(
                                        [
                                          'flights',
                                          indexFlight,
                                          'datetimeReturn',
                                        ],
                                        event.target.value,
                                      )
                                    }
                                    type="datetime-local"
                                  />
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </Col>
                        <Col md={2}>
                          <Button
                            bsStyle="danger"
                            className="pull-right"
                            onClick={() => this.removeFlight(indexFlight)}
                            style={{ marginTop: 25 }}
                          >
                            Eliminar
                          </Button>
                        </Col>
                      </Row>

                      <hr />
                    </div>
                  ))
                : null}
              <Row>
                <Col md={12}>
                  <div>
                    <Button
                      bsStyle="primary"
                      onClick={this.addFlight}
                      style={{ marginBottom: '15px' }}
                    >
                      Agregar vuelo
                    </Button>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <div className="form-group">
                    <label htmlFor="buyprice" style={{ fontWeight: '400' }}>
                      TARIFA NETA
                    </label>
                    <input
                      type="number"
                      step="any"
                      className="form-control"
                      id="buyprice"
                      value={formData.buyprice}
                      disabled={isPackage}
                      onChange={(event) =>
                        this.onChange('buyprice', event.target.value)
                      }
                    />
                  </div>
                </Col>

                <Col md={6}>
                  <div className="form-group">
                    <label htmlFor="price" style={{ fontWeight: '400' }}>
                      TARIFA PÚBLICA
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      id="price"
                      step="any"
                      value={formData.price}
                      disabled={isPackage}
                      onChange={(event) =>
                        this.onChange('price', event.target.value)
                      }
                    />
                  </div>
                </Col>
              </Row>
              <CommissionLabel
                price={formData.price}
                buyprice={formData.buyprice}
                isPackage={isPackage}
              />
              <Row>
                <Col md={12}>
                  <div className="form-group">
                    <label htmlFor="operator" style={{ fontWeight: '400' }}>
                      OPERADOR
                    </label>
                    <Select
                      required
                      placeholder="-- Seleccionar"
                      name="operator"
                      value={formData.operator}
                      options={optionsSelect.operators}
                      onChange={(value) => this.onChange('operator', value)}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <div className="form-group">
                    <label htmlFor="comments" style={{ fontWeight: '400' }}>
                      COMENTARIOS PARA EL CLIENTE
                    </label>
                    <textarea
                      type="text"
                      className="form-control"
                      id="comments"
                      value={formData.comments}
                      onChange={(event) =>
                        this.onChange('comments', event.target.value)
                      }
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <div className={'pull-right'} style={{ marginBottom: 15 }}>
                    <Button
                      bsStyle="primary"
                      style={{ marginRight: 10 }}
                      onClick={this.onCloseModal}
                    >
                      Regresar
                    </Button>
                    <Button bsStyle="primary" fill onClick={this.handledPrices}>
                      Guardar
                    </Button>
                  </div>
                </Col>
              </Row>
            </Grid>
          </form>
        </Modal>
      </div>
    );
  }
}

export default connect((state) => ({ Quotations: state.Quotations }))(
  flightQuotationAdd,
);



// WEBPACK FOOTER //
// ./src/views/Quotations/cards/flightQuotationAdd.js